import { cn } from "@/utils";
import { useEffect, useState, type ReactNode } from "react";

const DURATION_MS = 320;

type HermesCollapseProps = {
  open: boolean;
  children: ReactNode;
  className?: string;
};

/**
 * Abre e fecha um bloco **animando a altura** junto com a opacidade (grid-rows
 * `0fr` ↔ `1fr`): o conteúdo abaixo escorrega em vez de saltar. Fechado, o bloco
 * fica `inert` — nada dentro dele recebe foco nem clique. O `overflow` só fica
 * visível depois que a abertura termina, para menus que saem do bloco não serem cortados.
 */
export const HermesCollapse = ({
  open,
  children,
  className,
}: HermesCollapseProps) => {
  const [overflowVisible, setOverflowVisible] = useState(false);

  useEffect(() => {
    if (!open) {
      setOverflowVisible(false);
      return;
    }
    const timer = setTimeout(() => setOverflowVisible(true), DURATION_MS);
    return () => clearTimeout(timer);
  }, [open]);

  return (
    <div
      inert={!open}
      className={cn(
        "grid transition-[grid-template-rows,opacity] duration-300 ease-out motion-reduce:transition-none",
        open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0",
        className
      )}
    >
      <div
        className={cn(
          "min-h-0",
          overflowVisible ? "overflow-visible" : "overflow-hidden"
        )}
      >
        {children}
      </div>
    </div>
  );
};
